var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTornoProdutoImobiliario(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_838_6787",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 53
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 53,
    height: 53,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_838_6787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.91699 46.375V29.6426H15.449V46.375H4.91699ZM21.7343 46.375V29.6426H32.2664V46.375H21.7343ZM38.5516 46.375V29.6426H49.0837V46.375H38.5516ZM23.9426 44.1667H30.058V31.851H23.9426V44.1667ZM4.91699 23.3574V6.625H15.449V23.3574H4.91699ZM21.7343 23.3574V6.625H32.2664V23.3574H21.7343ZM38.5516 23.3574V6.625H49.0837V23.3574H38.5516ZM7.12533 21.149H13.2407V8.83333H7.12533V21.149ZM41.1846 21.149H46.8753V8.83333H41.1846V21.149Z",
    fill: "#FFBA69"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTornoProdutoImobiliario);
export default __webpack_public_path__ + "static/media/torno-produto-imobiliario.d3ba471e42072060f781db709374e681.svg";
export { ForwardRef as ReactComponent };